import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
    grid-area: CardPrimary;
    background-color: ${props => props.theme.colors.card};
    border-radius: 10px;

    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

    border: 2px;
    border-left: 8px;
    border-style: solid;
    border-color: ${props => props.theme.colors.primary};
    padding: clamp(1.25rem, 2.5vw, 1.875rem);

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    @media (max-width: 576px) {
        flex-direction: column;
        gap: 1rem;
        padding: clamp(1rem, 2vw, 1.25rem);
    }
`;

export const TextContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: clamp(0.5rem, 1vw, 0.75rem);
`;

export const Title = styled.span`
  color: ${props => props.theme.colors.primary};
  font-size: clamp(0.875rem, 1.2vw, 1rem);
  font-weight: 700;
`;

export const Value = styled.h2`
  color: ${props => props.theme.colors.text};
  font-size: clamp(1.25rem, 2vw, 1.375rem);
`;

export const ContainerSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.25rem, 0.5vw, 0.375rem);
`;

export const ButtonWrapper = styled.div`
  align-self: end;
  display: flex;
  flex-direction: row;
  gap: 8px;
  min-width: 120px;
  
  @media (max-width: 576px) {
    align-self: flex-start;
    min-width: 100%;
  }
`;

export const Subtitle = styled.span`
    color: ${props => props.theme.colors.primary};
    font-size: clamp(0.75rem, 1vw, 0.875rem);
`;

export const SecondaryValue = styled.span`
  color: ${props => props.theme.colors.text};
  font-size: clamp(0.875rem, 1.2vw, 1rem);
  font-weight: 700;
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  height: 100%;
`;
